import { Entity } from "./lenses"
import { run } from "./samples"

export * from "./lenses"

// run()

/* TODO:
* readme
* npm package
* article
*/
